import initReactApp from 'dpl/util/initReactApp';
import PaymentRequestModal from 'dpl/components/PaymentRequest/New/PaymentRequestModal';
import PaymentRequestModalV2 from 'dpl/components/PaymentRequest/New/PaymentRequestModalV2';
import StripeChargeUserHeaderMenu from 'dpl/components/StripeCharge/New/StripeChargeUserHeaderMenu';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';
import { FEATURES } from 'dpl/shared/constants/features';

initReactApp({
  StripeChargeUserHeaderMenu,
  ...(isFeatureEnabled(FEATURES.REL_PAYMENT_REQUEST_STEPS_V2)
    ? { PaymentRequestModalV2 }
    : { PaymentRequestModal })
});
